module.exports = __webpack_public_path__ + "img/VillaLoreto_Spa2jpg.f0582ad7.jpg";